// extracted by mini-css-extract-plugin
export default {"slot":"Fingering_slot__dVxoF","card":"Fingering_card__IodgM","pop":"Fingering_pop__WJ8ED","num":"Fingering_num__ry9QT"};